import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import AppModal from "../components/AppModal";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();
  const [modal, setModal] = useState({ isOpen: false, title: "", message: "", type: "info" });

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setErrorMsg("Token no válido o no proporcionado.");
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL || ""}/api/auth/verify-email/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => res.json().then(data => ({ status: res.status, ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          setSuccess(true);
        } else {
          setErrorMsg(data.error || "No se pudo verificar el correo.");
        }
      })
      .catch(() => setErrorMsg("Error de conexión al verificar el correo."))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <AuthShell
      eyebrow="Verificación de Correo"
      title="Verifica tu Correo"
      subtitle="Validando tu dirección de correo electrónico..."
      footerLinks={[{ to: "/login", label: "Ir a Inicio de Sesión" }]}
    >
      <div style={{ textAlign: "center", padding: "20px" }}>
        {loading ? (
          <p>Verificando tu correo electrónico, por favor espera...</p>
        ) : success ? (
          <div>
            <h3 style={{ color: "green" }}>¡Correo Verificado!</h3>
            <p>Tu correo ha sido verificado con éxito. Ya puedes iniciar sesión en la plataforma.</p>
            <button className="app-button app-button--primary" onClick={() => navigate("/login")} style={{ marginTop: "20px" }}>
              Iniciar Sesión
            </button>
          </div>
        ) : (
          <div>
            <h3 style={{ color: "red" }}>Error de Verificación</h3>
            <p>{errorMsg}</p>
            <button className="app-button app-button--secondary" onClick={() => navigate("/login")} style={{ marginTop: "20px" }}>
              Volver
            </button>
          </div>
        )}
      </div>

      <AppModal 
        isOpen={modal.isOpen} 
        title={modal.title} 
        message={modal.message} 
        type={modal.type} 
        onClose={() => setModal({ ...modal, isOpen: false })} 
      />
    </AuthShell>
  );
}
